import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { DataObject } from '@shared/models/data-object.model';
import { EntityType } from '@shared/models/entity-enum';
import { NSProviderType } from '@shared/models/navigation-source.const';
import { NavigationSourceFactoryService } from '@shared/services/navigation-source-factory.service';
import { isMasked } from '@shared/utils/helpers/sanitizers';

@Component({
  selector: 'miq-goes-to-record',
  templateUrl: 'goes-to-record.component.html',
  styleUrls: ['goes-to-record.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GoesToRecordComponent implements OnChanges {
  @Input() public id: string;
  @Input() public type: string;
  @Input() public classes: string;
  @Input() public useIcon = false;
  @Input() public urlParams: string[];
  @Input() public toolTipMessage: string;
  @Input() public toolTipPosition: string = 'below';
  @Input() public data: DataObject = null;
  @Input() public linkGenerator: (x: DataObject) => string[] = null;
  @Input() public dataParams = null;
  @Input() public svgIconName = 'open_in_browser';
  @Input() public targetAnchor = null;
  @Input() public navigateOptions: { type: NSProviderType; ids: number[]; entity: EntityType };
  @Input() public navigateOptionsFn: Function;

  public everythingOk = false;
  public internalParams: string[];

  constructor(private navigationSource: NavigationSourceFactoryService) {}

  ngOnChanges() {
    if (this.data && this.linkGenerator) {
      this.internalParams = this.linkGenerator(this.data);
      this.everythingOk = Array.isArray(this.internalParams) && this.internalParams.every(val => val != null);
    } else {
      const validUrlParams = this.urlParamsValid();
      const idTypeValid = this.idAndTypeValid();
      if (idTypeValid && !validUrlParams) {
        this.internalParams = ['/records', this.type, this.id, 'edit'];
        this.everythingOk = true;
      } else if (validUrlParams) {
        this.internalParams = this.urlParams;
        this.everythingOk = true;
      } else {
        this.everythingOk = false;
      }
    }
  }

  public onNavigate() {
    if (this.navigateOptionsFn != null) {
      this.navigateOptions = this.navigateOptionsFn();
    }
    if (this.navigateOptions?.type == NSProviderType.Static) {
      const { entity, ids } = this.navigateOptions;
      this.navigationSource.saveStaticNavigationSource({ entity, ids });
    }
  }

  private idAndTypeValid(): boolean {
    if (!!this.id && !!this.type) {
      return !!this.id && !!this.type && !isMasked(this.id);
    } else {
      return false;
    }
  }

  private urlParamsValid() {
    if (this.urlParams === undefined || this.urlParams.length === 0) {
      return false;
    }

    if (this.urlParams.some(x => !!!x || x === 'undefined' || isMasked(x))) {
      return false;
    }

    return true;
  }
}
